import dayjs from "dayjs";
import { RECEIPT_DATE_FORMAT } from "../constants";

function getReceiptDateTime() {
  return dayjs().format(RECEIPT_DATE_FORMAT);
}

export default getReceiptDateTime;
